import React, { useEffect } from 'react'
import ProcessingBoard from './views/ProcessingBoard'
import { useAnalytics } from 'use-analytics'
import { useAppContext } from '../../../context/AppContext'
import Suggestions from './views/Suggestions'

const waitAndExecute = (ms, fn) =>
  new Promise(r =>
    setTimeout(() => {
      fn()
      r()
    }, ms),
  )

const Results = () => {
  const { page } = useAnalytics()
  const {
    quiz: { answers, board, setResult },
  } = useAppContext()

  useEffect(() => {
    page()
    if (answers)
      waitAndExecute(3000, () => {
        setResult(answers)
      })
    //eslint-disable-next-line
  }, [answers])

  return board ? <Suggestions board={board} /> : <ProcessingBoard />
}

Results.propTypes = {}

export default Results
